import React, { useId } from "react";
import "./App.css";
import styled from "styled-components";
import Main from "./components/Main";
import giftCardData, { GiftCard } from "./components/cardData";
import CartModal from "./components/CartModal";
import { PackageTests, PackageT } from "./data";
import Header from "./components/Header";
import Footer from "./components/Footer";
import { v4 as uuid } from "uuid";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "bootstrap/dist/css/bootstrap.min.css";
import dotenv from "dotenv";
import Headers from "./components/Header2";

interface ShowModal {
  show: boolean;
}
const Container = styled.div<ShowModal>`
  position: relative;
  z-index: 1;
  overflow-x: hidden;
  width: 100%;
`;
export interface Cart {
  price: number;
  title: string;
  listOfTest?: string[];
  quantity?: number;
  totalPrice?: number;
  id?: string;
}
interface TotalPrice {
  totalPrice: number;
}
function App() {
  const dataSet = PackageTests.map((item, index) => ({
    ...item,
    id: uuid().slice(0, 8),
  }));

  const [packages, setPackages] = React.useState<PackageT[]>(dataSet);
  const [showModal, setShowModal] = React.useState<boolean>(false);
  const [filterParameter, setFilterParameter] = React.useState<string>("All");
  const [active, setActive] = React.useState<boolean>(true);
  const [cart, setCart] = React.useState<Cart[]>([]);
  const [totalPrice, setTotalPrice] = React.useState<number>(0);
  const [giftPackages, setGiftCardData] =
    React.useState<GiftCard[]>(giftCardData);

  React.useEffect(() => {
    if (cart.length !== 0) {
      handleSetPrice();
    }
  }, [cart]);
  console.log(cart);
  // get all MappedID

  const handleFilter = (parameter: string): void => {
    setFilterParameter(parameter);
    const filter = PackageTests.filter(
      (item) => item.packageCategory === parameter
    );
    setPackages(filter);
    if (active !== true) {
      setActive(true);
    }
  };
  const handleFilterForAllTag = () => {
    setFilterParameter("All");

    setPackages(PackageTests);
    if (active !== true) {
      setActive(true);
    }
  };
  const handleFilterForGift = (filter: string) => {
    setFilterParameter("Gift Cards");
    setActive(false);

    setPackages(PackageTests);
  };
  const handleShowModal = (): void => {
    setShowModal(!showModal);
  };
  const handleSetPrice = (): void => {
    let data = cart.map((item) =>
      item.totalPrice !== undefined ? item.totalPrice : 0
    );
    let totalPrice: number = 0;
    for (let i = 0; i < data.length; i++) {
      totalPrice += data[i];
    }
    const price = Math.ceil(totalPrice);
    setTotalPrice(price);
  };

  const addToCart = (item: Cart) => {
    item.quantity = 1;
    item.totalPrice = item.price;
    toast.success(`${item.title} is added to cart`, {
      autoClose: 3000,
      position: "top-center",
    });
    setCart((previousState) => [...previousState, item]);
  };
  const increaseQuantity = (item: Cart) => {
    item.quantity = item.quantity !== undefined ? item.quantity + 1 : 0;
    item.totalPrice = Math.ceil(
      item.price * (item.quantity ? item.quantity : 1)
    );
    setCart((previous) => [...previous]);
  };
  const decreaseQuantity = (item: Cart) => {
    item.quantity =
      item.quantity !== undefined && item.quantity > 0 ? item.quantity - 1 : 1;
    item.totalPrice = Math.ceil(
      item.price * (item.quantity ? item.quantity : 1)
    );
    setCart((previous) => [...previous]);
  };
  const removeFromCart = (id: string, title: string) => {
    let initData = cart.filter((item) => item.id !== id);
    setCart(initData);
    toast.success(`${title} is removed from cart`, {
      autoClose: 3000,
    });
  };
  console.log(cart);
  return (
    <Container show={showModal}>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      {/* Same as */}
      {/* 
      <Header
        handleShowModal={handleShowModal}
        numberOfCartItem={cart.length}
      />
      */}
      <Headers
        handleShowModal={handleShowModal}
        numberOfCartItem={cart.length}
      />

      <Main
        handleFilterForGift={handleFilterForGift}
        giftData={giftPackages}
        data={packages}
        handleFilter={handleFilter}
        handleFilterForAllTag={handleFilterForAllTag}
        filterParameter={filterParameter}
        active={active}
        addToCart={addToCart}
        cartData={cart}
      />
      <Footer />
      <CartModal
        show={showModal}
        handleShowModal={handleShowModal}
        cartData={cart}
        removeFromCart={removeFromCart}
        increaseQuantity={increaseQuantity}
        decreaseQuantity={decreaseQuantity}
        totalPrice={totalPrice}
        setCart={setCart}
        setShowModal={setShowModal}
      />
    </Container>
  );
}

export default App;
